import { request } from './client';

// Multi-target session (ADR-0039). Identity stays anchored to the home VP;
// a user may attach additional VP targets and switch which one is active.
// The active target governs which VP timesheet/draft/project data the
// backend reads and writes — never identity, roles, or sources.

export interface SessionTarget {
  id: string;
  displayName: string;
  active: boolean;
}

export function listTargets(): Promise<SessionTarget[]> {
  return request<SessionTarget[]>('/api/targets');
}

// Rotates the auth cookie server-side on success. Callers must refresh all
// app data after this resolves — a full reload is the safest way to catch
// every target-dependent query.
export function activateTarget(id: string): Promise<SessionTarget[]> {
  return request<SessionTarget[]>(`/api/targets/${encodeURIComponent(id)}/activate`, {
    method: 'POST',
  });
}

// Full-page navigation, not an XHR — GET /api/targets/attach/start 302s to
// the VP login page. Callers must use window.location.assign, not fetch.
export function attachTargetUrl(org: string): string {
  return `/api/targets/attach/start?org=${encodeURIComponent(org)}`;
}
